export const baseUrl = process.env.REACT_APP_API_URL;

export const LoginApi = 'login';
export const ResetPasswordApi = 'resetPassword';
export const UserLogoutApi = 'logout';
export const RefreshTokenApi = 'refreshToken';
export const getUserProfile = 'getUserProfile';
export const DealerLoginApi = 'dealers/login';
export const DealerResetPasswordApi = 'dealers/resetPassword';
